const INITIAL_STATE = {
  dismissedWarning: false
};

const types = {
  DISMISS_WARNING: 'orb/legal/DISMISS_WARNING'
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.DISMISS_WARNING:
      return Object.assign({}, state, {
        dismissedWarning: true
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;

export function dismissWarning() {
  return {
    type: types.DISMISS_WARNING
  };
}



// WEBPACK FOOTER //
// ./src/legal/reducer.js